"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const __1 = require("../..");
const S = (0, tslib_1.__importStar)(require("./styles"));
const PageSpinner = () => ((0, jsx_runtime_1.jsx)(S.SpinnerContainer, { children: (0, jsx_runtime_1.jsx)(__1.Spinner, { spinnerSize: 12 }, void 0) }, void 0));
exports.default = PageSpinner;
